import { IForm } from 'core-components/classes/models/IForm'
import { IAccessRequestStatus } from 'hpscm/classes/models/IAccessRequestStatus'
import { Crud } from 'src/core/types/Crud'
import { CrudInnerStorageFetcher } from 'src/core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'src/core/types/crudStore'

import { CrudStoreItem } from '../models/CrudStoreItem'

class InitializationService {
  public init = () => {
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('SupervisorHPID', {
          formId: 495,
          code: 'OrgChartOtherSupervisorsUnique',
        }),
        keyField: 'SupervisorHPID',
      }),
      CrudStoreItem.UniqueSupervisors
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IAccessRequestStatus>('EntryId', {
          formId: 1526,
          code: 'emailer-access-request-tracker-1526',
        }),
        keyField: 'EntryId',
        defaultSort: {
          field: 'EntryId',
          dir: 'desc',
        },
      }),
      CrudStoreItem.AccessRequestStatus
    )
  }
}

export default new InitializationService()
